module.exports = __webpack_public_path__ + "img/download-black.082cd863.svg";